import { OknoRoleTeacherType } from '../store/accept'
import http from './http'

export async function getOknoTeacherRole() {
	const res = await http.get('/okno/teacher')
	return res.data.Okno_role_teacher
}

export async function setOknoTeacher(form: OknoRoleTeacherType) {
	const res = await http.post('/okno/customer')
	return res.data.result
}

export async function getOknoStudentRole() {
	const res = await http.get('/okno/student')
	return res.data.Okno_role
}

export async function getAcceprProperties(param: number) {
	const res = await http.get('/okno/accept/proporties?customer=' + param)
	return res.data.Okno_proporties_list
}
